import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onSubmit: () => void
  onClose: () => void
  deleting: boolean
}

const DeleteFileModal = ({ onSubmit, onClose, deleting }: Props) => {
  const { company } = useCurrentSession()

  return (
    <Modal
      illustration="alert"
      title={i18n.t('bookkeepers.clients.payroll_cycles.documents.delete_modal.title')}
      description={i18n.t('bookkeepers.clients.payroll_cycles.documents.delete_modal.description', {
        company_name: company.name,
      })}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={deleting} type="negative" submit>
            {i18n.t('common.destroy')}
          </Button>
        </>
      }
    />
  )
}

export default DeleteFileModal
